import { put, select, takeLatest } from "redux-saga/effects"
import { Types as LoaderTypes } from "model/graphql"
import { Creators as analyzeRiskCreators } from "modules/analyze-risk-details/model"
import { chain, get } from "lodash"

function* handleLoadSuccess({ resource, data }) {
  if (resource === "groupedRiskContributors") {
    const { selectedGroup } = yield select(state => ({
      selectedGroup: get(state, "modules.analyzeRiskDetails.selectedGroup"),
    }))

    if (selectedGroup) {
      const selectedGroupExists = chain(data)
        .get("model.simulation.groupedRiskContributors")
        .some(item => item.id === selectedGroup.id)
        .value()

      if (!selectedGroupExists) {
        yield put(analyzeRiskCreators.hideGroup())
      }
    }
  }
}

export function* saga() {
  yield takeLatest(LoaderTypes.LOAD_SUCCESS, handleLoadSuccess)
}
